/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import Card from "@mui/material/Card";
import OGBox from "assets/theme/components/OGBox";
import OGTypography from "assets/theme/components/OGTypography";
import backgroundImageDay from "assets/images/others/bg-reset-cover2.jpeg";
import { useThemeUIController } from "context";

function AboutUs() {
  const [controller] = useThemeUIController();
  const { darkMode } = controller;
  return (
    <OGBox p={1} sx={{ display: "flex", justifyContent: "center" }}>
      <OGBox
        sx={{
          background: "none",
          backgroundImage: darkMode
            ? () => `url(${backgroundImageDay})`
            : () => `url(${backgroundImageDay})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        width="100%"
        borderRadius="md"
      >
        <Card
          sx={{
            opacity: 0.9,
            m: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <OGTypography sx={{ opacity: 1, m: 2, fontSize: 24, fontWeight: "bold" }}>
            ooGoal is a free football prediction service. <br />
          </OGTypography>
          <OGTypography sx={{ opacity: 1, m: 2, fontSize: 18, fontWeight: "bold" }}>
            Using an advanced predictive algorithm it can provide accurate football predictions for
            16 national leagues and statistical indicators based on the quantitative analysis of
            previous sports results.
            <br /> It is a project in continuous development for several years, which aims to
            provide the most accurate and engaging way to achieve the goals of a football lover.
            <br /> The service is currently maintained and developed by a single member with a
            passion for numbers, football and the web.
            <br /> Any disruptions are not intentional, but necessary for the improvement of the
            service.
          </OGTypography>
        </Card>
      </OGBox>
    </OGBox>
  );
}

export default AboutUs;
